// extracted by mini-css-extract-plugin
export default {"trilha":"styles_trilha__GmlVI"};